import { select, takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get } from 'lodash';
import userToken from 'containers/services/security/access-token-storage';
import { setUploadDocument } from 'containers/UploadDocumentsManager/actions';
import { UPLOAD_DOCUMENT_MANAGER } from 'containers/UploadDocumentsManager/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

/* istanbul ignore next */
export function* uploadDocument(action: any): Generator<unknown> {
  const token = get(userToken.get(), 'token')
    ? get(userToken.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  const path = get(userToken.get(), 'token')
    ? '/corporeal/v1/upload-documents'
    : '/corporeal/v1/upload-documents?isIntervenant=true';
  const formData = new FormData();
  formData.append('document', action.uploadFile);
  const options = {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const errorResponse = yield callApi(path, {}, options, [], setUploadDocument);
  if (errorResponse) {
    yield action.failedCallBack();
  }
}

export function* uploadDocumentSaga() {
  yield takeLeading(UPLOAD_DOCUMENT_MANAGER, uploadDocument);
}

export default [uploadDocumentSaga];
